import { render, staticRenderFns } from "./UserLoginForm.vue?vue&type=template&id=a53a7d50&"
import script from "./UserLoginForm.vue?vue&type=script&lang=ts&"
export * from "./UserLoginForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserLoginForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports